import { ToastOptions } from 'react-toastify';

export const TOASTIFY_CONFIGS: ToastOptions = {
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  theme: 'light',
};
